/**
 * @generated SignedSource<<8020489696d49388a68bc7b0828062da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoStatusEnum = "pending" | "processed" | "processing" | "processing_failed" | "processing_queued" | "processing_rejected" | "unprocessed";
export type CompleteVideoUploadInput = {
  clientMutationId?: string | null | undefined;
  videoId: string;
};
export type video_CompleteVideoUploadMutation$variables = {
  input: CompleteVideoUploadInput;
};
export type video_CompleteVideoUploadMutation$data = {
  readonly completeVideoUpload: {
    readonly video: {
      readonly id: string;
      readonly posterUrl: string | null | undefined;
      readonly question: {
        readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Question">;
      } | null | undefined;
      readonly rawId: number | null | undefined;
      readonly status: VideoStatusEnum;
      readonly url: string;
    } | null | undefined;
  } | null | undefined;
};
export type video_CompleteVideoUploadMutation = {
  response: video_CompleteVideoUploadMutation$data;
  variables: video_CompleteVideoUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "posterUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "video_CompleteVideoUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteVideoUploadPayload",
        "kind": "LinkedField",
        "name": "completeVideoUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AnswerListItem_Question"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "video_CompleteVideoUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompleteVideoUploadPayload",
        "kind": "LinkedField",
        "name": "completeVideoUpload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "kind": "LinkedField",
                    "name": "textualAnswer",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textualAnswer",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Answer",
                    "kind": "LinkedField",
                    "name": "videoAnswer",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Video",
                        "kind": "LinkedField",
                        "name": "video",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rejectReason",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95dee82f4be0e49daf9693ef308c64cb",
    "id": null,
    "metadata": {},
    "name": "video_CompleteVideoUploadMutation",
    "operationKind": "mutation",
    "text": "mutation video_CompleteVideoUploadMutation(\n  $input: CompleteVideoUploadInput!\n) {\n  completeVideoUpload(input: $input) {\n    video {\n      id\n      url\n      status\n      rawId\n      posterUrl\n      question {\n        ...AnswerListItem_Question\n        id\n      }\n    }\n  }\n}\n\nfragment AnswerListItemStatus_Video on Video {\n  id\n  status\n  rejectReason\n}\n\nfragment AnswerListItem_Question on Question {\n  rawId\n  id\n  title\n  textualAnswer {\n    id\n    textualAnswer\n  }\n  videoAnswer {\n    video {\n      ...AnswerListItem_Video\n      id\n    }\n    id\n  }\n}\n\nfragment AnswerListItem_Video on Video {\n  id\n  url\n  ...AnswerListItemStatus_Video\n}\n"
  }
};
})();

(node as any).hash = "f1da1ea470509ecb42d42ac2158b676c";

export default node;
